import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'context/AuthContext';
import { getUnitOptionsRequest } from '@/api';
import { UnitOptionsResponse } from '@/types/api-types';

export function useGetUnitOptions() {
  const { isAuthenticated } = useAuth();

  return useQuery<UnitOptionsResponse>({
    queryKey: ['unitOptions'],
    queryFn: async () => {
      const response = await getUnitOptionsRequest();
      return response.data;
    },
    enabled: isAuthenticated,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
